import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React, { Component } from 'react';
import Header from '../Header';
import PropTypes from 'prop-types';
import Footer from '../Footer';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.forgotpassword.label.name',
    description: 'Page Header Title',
    defaultMessage: 'Forgot Password'
  },
  headerSubTitle: {
    id: 'empty.label.name',
    description: 'Page Header Subtitle',
    defaultMessage: ' '
  }
});

class PasswordForgotMsg extends Component {
  //const { intl } = props;
  static propTypes = {};

  constructor(props) {
    super(props);
    const { intl } = this.props;
  }

  render() {
    return (
      <div className="preview page">
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          //subtitle={this.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
          status = {this.props.status}
        />

        <div className="main">
          <div
            className="panel"
            style={{
              width: '60%',
              padding: '40px',
              boxSizing: 'content-box',
              marginTop: '15px',
              display: 'block',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            <div className="form">
              <label
                style={{
                  width: '90%',
                  fontSize: '16px',
                  textTransform: 'none',
                  lineHeight: '150%'
                }}
              >
                You have successfully reset your password. Your new password has
                been sent to you via email.
              </label>
              <br />
              &nbsp;
              <br />
              &nbsp;
              <div className="button-container" style={{ textAlign: 'center' }}>
                <button
                  className="button"
                  styel={{ padding: 20 }}
                  type="button"
                  onClick={() => this.props.clickLoginHandler()}
                >
                  <FormattedMessage id="nav.ok" defaultMessage="OK" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

PasswordForgotMsg.propTypes = {
  clickLoginHandler: PropTypes.func
};

export default injectIntl(PasswordForgotMsg);



// WEBPACK FOOTER //
// ./src/components/views/PasswordForgotMsg/index.js